import { z } from 'zod';
import { WebBlocksApiComponentT } from '../../lib/REST/types.d';

const component: z.ZodSchema<WebBlocksApiComponentT> = z.lazy(() =>
	z
		.object({
			type: z.string(),
			props: z
				.object({
					children: z
						.union([component, z.array(component), z.string()])
						.optional()
						.nullable(),
				})
				.passthrough(),
		})
		.passthrough()
);

const commonOpts = z.object({
	campaignId: z.string().nonempty(),
	selector: z.string().nonempty(),
});

const blockNormal = z.intersection(
	commonOpts,
	z.object({
		contentId: z.string().nonempty(),
		customJs: z.string().url().optional(),
		component,
	})
);

const blockDefault = z.intersection(
	commonOpts,
	z.object({
		contentId: z.literal('default'),
	})
);

const blockCustomJsNoContent = z.object({
	campaignId: z.string().nonempty(),
	contentId: z.string().nonempty(),
	customJs: z.string().url().nonempty(),
	component: z.null().optional(),
	selector: z.null().optional(),
});

export const blockSchema = z.union([
	blockDefault,
	blockNormal,
	blockCustomJsNoContent,
]);
